"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var logger_1 = tslib_1.__importDefault(require("../utils/logger"));
var BaseTransport = /** @class */ (function () {
    function BaseTransport(options) {
        this.options = options;
    }
    BaseTransport.prototype.send = function (value) {
        if (this.options.api) {
            return this.options.api(value);
        }
        if (!this.options.endpoint) {
            logger_1.default.warn('endpoint 不能为空');
            return Promise.reject(false);
        }
        return this.doSend(value);
    };
    return BaseTransport;
}());
exports.default = BaseTransport;
//# sourceMappingURL=baseTransport.js.map